import { ControllerFlowAPI } from '@wix/yoshi-flow-editor';
import { getChallengeSlugFromLocation } from '../../../Location/locationProviderPropsMap';
import { ChallengeServerlessData } from '../../../../types/challenge-serverless';
import requestChallenge from '../api/requestChallenge';
import { shouldReportErrorMonitor } from './shouldReportErrorMonitor';
import { handleError } from '../../../ErrorHandler/errorHandlerPropsMap';
import {
  addOnLoginHandler,
  IOnLoginHandlerPriority,
} from '../../../GeneralDataProvider/helpers/onLogin';

export function handleChallengeAfterLogin() {
  addOnLoginHandler({
    priority: IOnLoginHandlerPriority.SECONDARY,
    handler: async (flowAPI: ControllerFlowAPI) => {
      const challengeId = getChallengeSlugFromLocation(flowAPI);

      let challengeData: ChallengeServerlessData = {
        challenge: null,
      };

      try {
        if (challengeId) {
          challengeData = await requestChallenge(challengeId, flowAPI);
        }
      } catch (error) {
        handleError({
          error,
          context: 'onUserLogin.getChallenge',
          preventErrorMonitorReport: !shouldReportErrorMonitor(error),
        });
      }

      flowAPI.controllerConfig.setProps({
        challengeData,
      });
    },
  });
}
